var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileNavInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.353,
    height: 15.871,
    viewBox: "0 0 11.353 15.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile_nav_information_icon",
    transform: "translate(-34.762 -707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mobile_nav_information_icon-2",
    "data-name": "mobile_nav_information_icon",
    d: "M5.317,10.76,8.83,4.174l-1.568-2.9a.363.363,0,0,0-.68.124Zm10.634,3.108L10.543,16.91a.363.363,0,0,1-.356,0L4.968,13.975A.363.363,0,0,1,4.89,13.4l8.983-8.983a.363.363,0,0,1,.614.191l1.644,8.876A.363.363,0,0,1,15.951,13.868Zm-4.1-8.459L5.726,11.538l4.332-8.122a.363.363,0,0,1,.635-.011Z",
    transform: "translate(29.979 705.914)",
    fill: "#7c4dff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNavInformationIcon);
export default __webpack_public_path__ + "static/media/mobile_nav_information_icon.1ab00db9eae2662ec52d47435087da1d.svg";
export { ForwardRef as ReactComponent };